<a class="input-button text-mustard" data-toggle>
    <i class="fa fa-calendar"></i>
</a>